export enum ComplaintAffair {
  SIGN_UP_AND_LOG_IN = 'SIGN_UP_AND_LOG_IN',
  PUNCTUALITY = 'PUNCTUALITY',
  VEHICLE_CONDITIONS = 'VEHICLE_CONDITIONS',
  DRIVER = 'DRIVER',
  BOOKINGS_AND_CANCELLATIONS = 'BOOKINGS_AND_CANCELLATIONS',
  PENALTIES = 'PENALTIES',
  APP = 'APP',
  BACKOFFICE = 'BACKOFFICE',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  OTHERS = 'OTHERS',
}
